import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/contexts/AuthContext';
import DashboardLayout from './components/layout/DashboardLayout';
import LoginPage from './components/pages/LoginPage';
import RegisterPage from './components/pages/RegisterPage';
import OwnerDashboard from './components/pages/OwnerDashboard';
import MashellDashboard from './components/pages/MashellDashboard';  // updated dashboard
import PassengerDashboard from './components/pages/PassengerDashboard';
import AddVehicle from './components/owner/AddVehicle';
import VehicleList from './components/owner/VehicleList';
import TransactionReport from './components/owner/TransactionReport';
// BoardingPanel removed – now integrated inside MashellDashboard
import WalletTopup from './components/passenger/WalletTopup';
import AvailableTrips from './components/passenger/AvailableTrips';
import PaymentInitiation from './components/passenger/PaymentInitiation';
import TransactionHistory from './components/passenger/TransactionHistory';
import Spinner from './components/common/Spinner';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner />;
  if (!user) return <Navigate to="/login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/dashboard" />;
  return children;
};

const DashboardRedirect = () => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" />;
  switch (user.role) {
    case 'owner': return <Navigate to="/owner" />;
    case 'mashell': return <Navigate to="/mashell" />;
    case 'passenger': return <Navigate to="/passenger" />;
    default: return <Navigate to="/login" />;
  }
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<DashboardRedirect />} />
          
          {/* Owner routes */}
          <Route element={<ProtectedRoute allowedRoles={['owner']}><DashboardLayout /></ProtectedRoute>}>
            <Route path="/owner" element={<OwnerDashboard />} />
            <Route path="/owner/add-vehicle" element={<AddVehicle />} />
            <Route path="/owner/vehicles" element={<VehicleList />} />
            <Route path="/owner/transactions" element={<TransactionReport />} />
          </Route>

          {/* Mashell routes – now using the combined dashboard */}
          <Route element={<ProtectedRoute allowedRoles={['mashell']}><DashboardLayout /></ProtectedRoute>}>
            <Route path="/mashell" element={<MashellDashboard />} />
            <Route path="/mashell/queue" element={<MashellDashboard />} />   {/* keep for sidebar links */}
          </Route>

          {/* Passenger routes */}
          <Route element={<ProtectedRoute allowedRoles={['passenger']}><DashboardLayout /></ProtectedRoute>}>
            <Route path="/passenger" element={<PassengerDashboard />} />
            <Route path="/passenger/topup" element={<WalletTopup />} />
            <Route path="/passenger/trips" element={<AvailableTrips />} />
            <Route path="/passenger/pay/:tripId" element={<PaymentInitiation />} />
            <Route path="/passenger/history" element={<TransactionHistory />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;